/* eslint-disable import/no-unresolved */
import { config, modulesList } from '@/include/config';
import {
  createRouter,
  createWebHistory,
  createWebHashHistory
  //RouteRecordRaw,
} from 'vue-router';
// 第一層 ROUTER
import Home from '@/views/Home.vue';
import News from '@/views/News.vue';
import NewsItem from '@/views/NewsItem.vue';
import Company from '@/views/Company.vue';
import Products from '@/views/Products.vue';
import ProductSeriesItem from '@/views/ProductSeriesItem.vue';
import Contact from '@/views/Contact.vue';
import ChangeLog from '@/views/ChangeLog.vue';
import TronEdu from '@/views/TronEdu.vue';
import TronMap from '@/views/TronMap.vue';
import TronSecurity from '@/views/TronSecurity.vue';
import TronEduItem from '@/views/TronEduItem.vue';
import TronMapItem from '@/views/TronMapItem.vue';
import TronSecurityItem from '@/views/TronSecurityItem.vue';
import CRStream from '@/views/CRStream.vue';
import TronEduExamEditor from '@/views/TronEduExamEditor.vue';
import CRStreamConvert from '@/views/CRStreamConvert.vue';

// 第二層 Router

// 系統管理
import AuthPage from '@/router/AuthPage';

// .net core module
//import DCSysMs from '@/router/dotnet/SysMs';
//import DCFunMs from '@/router/dotnet/FunMs';

// php module
import SysMs from '@/router/php/SysMs';

const routes = [
  /*
  {
    path: '/',
    redirect: '/SysMs/AdminRoles',
  },
  */
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/News',
    name: 'News',
    component: News
  },
  {
    path: '/NewsItem',
    name: 'NewsItem',
    component: NewsItem
  },
  {
    path: '/Company',
    name: 'Company',
    component: Company
  },
  {
    path: '/Products',
    name: 'Products',
    component: Products
  },
  {
    path: '/ProductSeriesItem',
    name: 'ProductSeriesItem',
    component: ProductSeriesItem
  },
 
  {
    path: '/TronEdu',
    name: 'TronEdu',
    component: TronEdu
  },
  {
    path: '/TronMap',
    name: 'TronMap',
    component: TronMap
  },
  {
    path: '/TronSecurity',
    name: 'TronSecurity',
    component: TronSecurity
  },

  {
    path: '/TronEduItem',
    name: 'TronEduItem',
    component: TronEduItem
  },
  {
    path: '/TronMapItem',
    name: 'TronMapItem',
    component: TronMapItem
  },
  {
    path: '/TronSecurityItem',
    name: 'TronSecurityItem',
    component: TronSecurityItem
  },
  {
    path: '/CRStreamConvert',
    name: 'CRStreamConvert',
    component: CRStreamConvert
  },
  {
    path: '/TronEduExamEditor',
    name: 'TronEduExamEditor',
    component: TronEduExamEditor
  },
  {
    path: '/CRStream',
    name: 'CRStream',
    component: CRStream
  },
  {
    path: '/ChangeLog',
    name: 'ChangeLog',
    component: ChangeLog
  },


  {
    path: '/Contact',
    name: 'Contact',
    component: Contact
  },



  SysMs,
];

routes.push(AuthPage);




const router = createRouter({
  //history: createWebHashHistory(config.baseUrl),
  //history: createWebHashHistory(),
  //history: createWebHistory(config.baseUrl),
  //history: createWebHistory(),
  history:
  process.env.NODE_ENV === 'production' ?
    //createWebHashHistory() :
    createWebHistory() : 
    createWebHistory(),
  linkActiveClass: 'cur',
  linkExactActiveClass: 'cur',
  routes
});

router.isReady().then(() => {
  //console.log('is Ready!!!!');
});

export default router;
